//* ------------------------------------*\
//    $ARIA STRINGS
//* ------------------------------------*/

const ARIA = {
  ACTIVE_DESCENDANT: 'aria-activedescendant',
  EXPANDED: 'aria-expanded',
  HIDDEN: 'aria-hidden',
  INVALID: 'aria-invalid',
  LABELLED_BY: 'aria-labelledby',
  SELECTED: 'aria-selected'
};

export default ARIA;
